import { SetStateAction, useContext, useEffect, useState } from "react";
import { MenuItem, Paper, Select, Snackbar, TableContainer, Toolbar, Typography } from "@mui/material";
import React from "react";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { useLocation } from "react-router-dom";
import { del, get, post } from "../../../Services/tokenConfig";
import { func_print } from "../../../Func_genericas/func_print";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { Alert } from "../../../Components/Alert/Alert";
import LoadingVulpesSmall from "../../../Styles/Loader/loadingSmall";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { ICabecalho7 } from "../../../Interfaces/cadernos/caderno7";
import { IPage3 } from "../../../Interfaces/cadernos/caderno3";
import BasicPopover from "../../../Components/Popover";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";



interface CabecalhoForm_prop {
  set_obj_anexo_cabecalho_selecionado: React.Dispatch<SetStateAction<ICabecalho7 | undefined>>;
  obj_anexo_cabecalho_selecionado: ICabecalho7 | undefined;
}

export const CabecalhoForm: React.FC<CabecalhoForm_prop> = ({
  obj_anexo_cabecalho_selecionado
  , set_obj_anexo_cabecalho_selecionado }) => {
  const auth = useContext(AuthContext);

  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const [especie_ou_lote_homegenio_selecionada, set_especie_ou_lote_homegenio_selecionada] = useState<IPage3>();
  const [especie_ou_lote_homegenio_lista, set_especie_ou_lote_homegenio_lista] = useState<IPage3[]>([]);

  const [obj_anexo_cabecalho, set_obj_anexo_cabecalho] = useState<ICabecalho7>();
  const [obj_anexo_cabecalho_lista, set_obj_anexo_cabecalho_lista] = useState<ICabecalho7[]>();
  const [obj_anexo_cabecalho_to_edit, set_obj_anexo_cabecalho_to_edit] = useState<ICabecalho7>();

  const [isLoading, setIsLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [open_dialog_tem_a_certeza_que_quer_eliminar, set_open_dialog_tem_a_certeza_que_quer_eliminar] = useState(false);

  const [flag_editar_cabecalho, set_flag_editar_cabecalho] = useState(false)

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState(false);
  const [openSnackError, setOpenSnackError] = React.useState(false);




  const handleCloseSnack = () => {
    setOpenSnackSuccess(false);
    setOpenSnackError(false);
  };


  const get_info = async () => {
    try {

      let res = await get(auth.token.cookie_token,
        `/zona_homgenea_Lista/${location.state.id_rosto}`
        // `/get_reg_anexo_um__cabecalho_rosto/${location.state.id_rosto}`
      );
      let res_cabecalho = await get(auth.token.cookie_token,
        `/get_reg_producao_animal_sete_cabecalho_rosto/${location.state.id_rosto}`
        // `/get_reg_anexo_um_um_cabecalho/${location.state.id_rosto}`
      );
      if (res.status === 200 && res_cabecalho.status === 200) {
        if (res.data.result.length !== 0) {
          set_especie_ou_lote_homegenio_lista(res.data.result);
          set_especie_ou_lote_homegenio_selecionada(res.data.result[0])
          if (res_cabecalho.data.result.length !== 0) {
            set_obj_anexo_cabecalho_lista(res_cabecalho.data.result)
            let obj_aux = res_cabecalho.data.result?.find((el: ICabecalho7) => el.grupo_homo === res.data.result[0].grupo_homoge)
            set_obj_anexo_cabecalho_to_edit(obj_aux)
            set_obj_anexo_cabecalho_selecionado(obj_aux)

            set_obj_anexo_cabecalho(obj_aux)
          } else {
            set_flag_editar_cabecalho(true)

          }
        }
      }

      setIsLoading(false);
    } catch (error) {
      func_print("get_info", error, true);
      setMessage("Erro!");

      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  const handle_change_zona_homogenea = (zona_homogenea_selecionada: string) => {
    set_obj_anexo_cabecalho_selecionado(undefined)

    let aux_obj_zona_homogenea_selecionada = especie_ou_lote_homegenio_lista.find((el: IPage3) => el.grupo_homoge === zona_homogenea_selecionada)

    set_especie_ou_lote_homegenio_selecionada(aux_obj_zona_homogenea_selecionada)
    let obj_aux = obj_anexo_cabecalho_lista?.find((el: ICabecalho7) => el.grupo_homo === zona_homogenea_selecionada)
    if (obj_aux === undefined) {
      set_flag_editar_cabecalho(true)
    } else {
      set_flag_editar_cabecalho(false)

    }
    set_obj_anexo_cabecalho(obj_aux)
    set_obj_anexo_cabecalho_to_edit(obj_aux)
    set_obj_anexo_cabecalho_selecionado(obj_aux)


  }

  const handle_criar_cabecalho = async () => {


    try {
      setIsLoading(true);

      let data = await post(auth.token.cookie_token, "new_reg_producao_animal_sete_cabecalho", {
        payload: {
          id_registo_pro: 0,
          grupo_homo: especie_ou_lote_homegenio_selecionada?.grupo_homoge === undefined ? null : especie_ou_lote_homegenio_selecionada?.grupo_homoge,
          especi: obj_anexo_cabecalho_to_edit?.especi === undefined ? null : obj_anexo_cabecalho_to_edit?.especi,
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: ""
        }
      })
      if (data.status === 200) {
        setMessage("Operação efetuada com sucesso!");
        setOpenSnackSuccess(true);
        set_obj_anexo_cabecalho(data.data.result)
        set_obj_anexo_cabecalho_to_edit(data.data.result)
        if (obj_anexo_cabecalho_lista?.length === 0 || obj_anexo_cabecalho_lista === undefined) {
          set_obj_anexo_cabecalho_lista([data.data.result])

        } else {
          set_obj_anexo_cabecalho_lista((old: any) => [...old, data.data.result])

        }

        set_obj_anexo_cabecalho_to_edit(data.data.result)
        set_obj_anexo_cabecalho_selecionado(data.data.result)
        set_flag_editar_cabecalho(false)

      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error) {
      func_print('handle_criar_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);

    }

  }
  const handle_editar_cabecalho = async () => {

    try {
      setIsLoading(true);

      let data = await post(auth.token.cookie_token, "update_reg_producao_animal_sete_cabecalho", {
        payload: {
          id_registo_pro: obj_anexo_cabecalho_to_edit?.id_registo_pro === undefined ? null : obj_anexo_cabecalho_to_edit?.id_registo_pro,
          grupo_homo: especie_ou_lote_homegenio_selecionada?.grupo_homoge === undefined ? null : especie_ou_lote_homegenio_selecionada?.grupo_homoge,
          especi: obj_anexo_cabecalho_to_edit?.especi === undefined ? null : obj_anexo_cabecalho_to_edit?.especi,
          id_rosto: location.state.id_rosto,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: ""
        }
      })


      if (data.status === 200) {
        setMessage("Operação efetuada com sucesso!");
        setOpenSnackSuccess(true);
        set_flag_editar_cabecalho(false)

        set_obj_anexo_cabecalho_to_edit(data.data.result)
        set_obj_anexo_cabecalho(data.data.result)
        set_obj_anexo_cabecalho_selecionado(data.data.result)

      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {
      func_print('handle_editar_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
    }


  }
  const handle_delete_cabecalho = async () => {
    try {
      set_open_dialog_tem_a_certeza_que_quer_eliminar(false)
      setIsLoading(true);
      let data = await del(auth.token.cookie_token, `delete_producao_animal_sete_cabecalho/${obj_anexo_cabecalho?.id_registo_pro}`)
      if (data.status === 200) {
        func_print('obj_anexo_cabecalho_lista', obj_anexo_cabecalho_lista)
        let lista_aux: any = obj_anexo_cabecalho_lista?.filter((el) => {
          if (el.id_registo_pro !== obj_anexo_cabecalho?.id_registo_pro) {
            return el
          }
        })
        setMessage("Eliminado com sucesso!");
        setOpenSnackSuccess(true);
        set_obj_anexo_cabecalho_lista(lista_aux === undefined ? [] : lista_aux)
        set_obj_anexo_cabecalho_selecionado(undefined)
        set_obj_anexo_cabecalho(undefined)
        set_obj_anexo_cabecalho_to_edit(undefined)
        set_flag_editar_cabecalho(true)
      } else {
        setMessage("Erro ao efetuar a sua operação!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error) {

      func_print('handle_delete_cabecalho', error, true)
      setIsLoading(false);

      setMessage("Erro ao efetuar a sua operação!");
      setOpenSnackError(true);
    }
  }

  useEffect(() => {
    (async () => {
      await get_info();
    })();
  }, []);

  return (
    <form>
      <CustomThemeProvider>
        <TableContainer
          component={Paper}
          variant="outlined"
          sx={{
            height: "auto",
            width: "auto",
            margin: 2,
            padding: 2,
          }}
        >
          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={handleCloseSnack}
          >
            <Alert
              onClose={handleCloseSnack}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          {isLoading ?
            <LoadingVulpesSmall />
            :
            <Toolbar
              style={{
                paddingTop: 3,
                paddingBottom: 10,
                fontFamily: "candara",
                display: "flex",
                flexDirection: 'column',
              }}
            >
              <div style={{
                width: '100%',

              }}
              >
                <div
                  style={{
                    display: "flex",
                    flexDirection: 'row',
                  }}
                >
                  <h1
                    style={{
                      fontWeight: 600,
                      fontSize: 20,
                      fontFamily: "candara",
                    }}
                  >
                    7 - Registo de Produção Animal
                  </h1>
                  <BasicPopover
                    text={
                      "Registo obrigatório para AB e PRODI quando obeneficiário detém animais certificados em Agricultura Biológica ou PRODI."
                    }
                  />
                </div>
                <div style={{
                  width: '100%',
                  display: "flex",
                  flexDirection: 'row',
                  alignItems: 'flex-end',
                  justifyContent: 'flex-end',

                }}>
                  {
                    especie_ou_lote_homegenio_lista.length === 0 ? <></> :

                      obj_anexo_cabecalho === undefined ?
                        is_historico === true ? <></> :

                          <ButtonCadernos

                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_criar_cabecalho() }}
                          />
                        :
                        flag_editar_cabecalho === true ?
                          <ButtonCadernos
                            mostrarBotaoCancelar
                            aoClicarCancelar={() => {
                              set_flag_editar_cabecalho(false)
                            }}
                            mostrarBotaoGravar
                            aoClicarGravar={() => { handle_editar_cabecalho() }}
                          /> :
                          is_historico === true ? <></> :

                            <ButtonCadernos
                              mostrarBotaoApagar
                              mostrarBotaoEditar
                              aoClicarApagar={() => { set_open_dialog_tem_a_certeza_que_quer_eliminar(true) }}
                              aoClicarEditar={() => { set_flag_editar_cabecalho(true) }}
                            />


                  }
                </div>
                <div style={{
                  display: "flex",
                  flex: 1,
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexDirection: 'row',

                }}>
                  <div style={{
                    display: "flex",
                    flex: 0.5,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',

                  }}>
                    Grupo Homogéneo
                    <Select
                      value={especie_ou_lote_homegenio_selecionada?.grupo_homoge === undefined ? '' : especie_ou_lote_homegenio_selecionada?.grupo_homoge}
                      label={''}
                      name={'zona_homogenea'}
                      sx={{
                        fontSize: 14,
                        fontFamily: "verdana",
                        minWidth: 200,
                      }}
                      onChange={(e) => handle_change_zona_homogenea(e.target.value)}
                    >

                      {especie_ou_lote_homegenio_lista.sort((a, b) =>
                        a.grupo_homoge.localeCompare(b.grupo_homoge, 'pt', {
                          sensitivity: 'base',
                        })
                      ).map((item: IPage3, key) => {

                        return (
                          <MenuItem key={key} value={item.grupo_homoge}>
                            <Typography
                              style={{
                                fontSize: 14,
                                fontFamily: "candara",
                              }}
                            >
                              {item.grupo_homoge}
                            </Typography>
                          </MenuItem>
                        );
                      })}
                    </Select>
                  </div>

                  <div style={{
                    display: "flex",
                    flex: 0.5,
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexDirection: 'row',
                    marginRight: '2%',

                  }}>
                    Espécie animal:{especie_ou_lote_homegenio_selecionada?.epecie}
                    {/* <CustomTextField
                      disabled={!flag_editar_cabecalho}
                      name="obtida"
                      value={obj_anexo_cabecalho_to_edit?.obtida === undefined ? '' : obj_anexo_cabecalho_to_edit?.obtida}
                      onChange={onInputEditTableChange_cabecalho}
                      error={error_obtida}
                      helperText={error_obtida ? 'Apenas números são aceites' : ""}
                    /> */}
                  </div>


                </div>


              </div>
            </Toolbar>

          }
        </TableContainer>
      </CustomThemeProvider>
      <ConfirmDialog
        open={open_dialog_tem_a_certeza_que_quer_eliminar}
        onClose={() => set_open_dialog_tem_a_certeza_que_quer_eliminar(false)}
        onConfirm={handle_delete_cabecalho}
        message="Deseja eliminar o registo?"
      />
    </form>
  );
};
